import { Field } from 'formik';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { FsProps } from './FsProps';
import { CustomSelectComponent } from './custom-select';

export const FieldSelectApprove = ({
  label = 'Επιλογή',
  name,
  disable = false,
  ...rest
}: FsProps & { readonly disable?: boolean }) => {
  const { t, i18n } = useTranslation();
  //
  const options = [
    { value: true, label: i18n.language === 'gr' ? t('ΝΑΙ') : t('YES') },
    { value: false, label: i18n.language === 'gr' ? t('ΟΧΙ') : t('NO') },
    {
      value: 'wait',
      label: i18n.language === 'gr' ? t('ΑΝΑΜΟΝΗ') : t('PENDING'),
    },
  ];

  return (
    <Field
      className="mb-2"
      name={name}
      title={label}
      component={CustomSelectComponent}
      options={options}
      isDisabled={disable}
    />
  );
};

